export let data = {
  title: "Data Operasi",
  backBtn: "/operasi",
  actionBtn: [],
  breadcrumb: [
    { title: "Operasi", link: "/operasi" },
    { title: "Input Data Operasi", active: true }
  ]
};
export let today=new Date();
import {getTime} from './helper.js';
export let time=getTime(today.getHours(),today.getMinutes());
export let upperForm = [
  {
    colnum: 3,
    columns: [
      {
        label: "Tanggal operasi",
        type: "date",
        placeholder: "",
        name: "tanggal",
        value: "",
        additional: ""
      },
      {
        label: "Mulai operasi pukul",
        type: "time",
        placeholder: "",
        name: "sign_in",
        value: "",
        additional: ""
      },
      {
        label: "Selesai operasi pukul",
        type: "time",
        placeholder: "",
        name: "sign_out",
        value: "",
        additional: ""
      }
    ]
  },
];
export let leftForm = [
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "pre_daerah_operasi",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Daerah sekitar operasi",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "pre_daerah_operasi_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "pre_puasa",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Puasa",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "pre_puasa_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "pre_klisma",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Klisma",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "pre_klisma_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "pre_surat_izin",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Surat izin operasi dan anastesi",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "pre_surat_izin_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "pre_tanda_vital",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Tanda vital",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "pre_tanda_vital_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "pre_katheter",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Terpasang katheter",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "pre_katheter_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "pre_infus",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Terpasang infus",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "pre_infus_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "pre_premedikasi",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Obat premedikasi",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "pre_premedikasi_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "pre_alergi",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Alergi",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "pre_alergi_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "pre_perhiasan",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Perhiasan dilepas",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "pre_perhiasan_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "pre_make_up",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Make up, kutek di hapus",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "pre_make_up_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "pre_aksesoris",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Gigi palsu, rambut palsu, lensa kontak, hearing",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "pre_aksesoris_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "pre_hasil_lab",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Hasil lab/Radiologi EKG terlampir di status",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "pre_hasil_lab_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "pre_status",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Status lengkap",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "pre_status_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "pre_persediaan_darah",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Persediaan darah/Go",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "pre_persediaan_darah_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "pre_pilek_batuk",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Pilek, batuk",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "pre_pilek_batuk_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "pre_darah",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Darah lengkap",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "pre_darah_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "pre_pemeriksaan",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Pemeriksaan BT,CT",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "pre_pemeriksaan_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "pre_haid",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Haid",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "pre_haid_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "pre_konsul_anestesi",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Konsul Anestesi",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "pre_konsul_anestesi_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "pre_acc_adm_kasir",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "ACC Adm/Kasir",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "pre_acc_adm_kasir_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
]
export let rightForm = [
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "post_infus",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Terpasang infus",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "post_infus_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "post_ngt",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Terpasang NGT",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "post_ngt_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "post_drain",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Terpasang drain",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "post_drain_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "post_tampon",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Terpasang tampon",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "post_tampon_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "post_katheter",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Terpasang katheter",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "post_katheter_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "post_pemeriksaan",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Pemeriksaan",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "post_pemeriksaan_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "post_laporan_pembedahan",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Laporan pembedahan",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "post_laporan_pembedahan_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "post_instruksi",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Instruksi post operasi",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "post_instruksi_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "post_laporan_anestesi",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Laporan Anestesi",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "post_laporan_anestesi_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "post_resep",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Resep",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "post_resep_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "post_hasil_lab",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Hasil Lab/Radiologi/EKG",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "post_hasil_lab_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "post_darah_sisa",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Darah sisa",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "post_darah_sisa_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "post_format_biaya",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Form biaya Adm",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "post_format_biaya_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "post_format_observasi",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Form Observasi Keperawatan",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "post_format_observasi_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "post_tanda_vital_td",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Tanda vital (TD)",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "post_tanda_vital_td_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "post_tanda_vital_n",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Tanda vital (N)",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "post_tanda_vital_n_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "post_tanda_vital_r",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Tanda vital(R)",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "post_tanda_vital_r_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "post_tanda_vital_s",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Tanda vital(S)",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "post_tanda_vital_s_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  },
  {
    colnum: 2,
    columns: [
      {
        label: "",
        type: "checkbox_old",single:true,
        name: "post_tanda_vital_spo2",
        value: 0,
        mandatory: false,
        optional:true,
        multiple: false,
        options: [
          {
            label: "Tanda vital (SpO2)",
            value: 1
          }
        ],
      },
      {
        label: "",
        type: "text",
        placeholder: "keterangan",
        name: "post_tanda_vital_spo2_keterangan",
        value: "",
        mandatory: false,
        optional:true,
        additional: ""
      }
    ]
  }
]